import { excludedCategoryCodes } from '../../const/excludedCategoryCodes';
import { CatalogueCategory } from '../../models/services/api/getCatalogue';

/**
 * @description Removes any catalogue categories that aren't registerable for the given brand, as
 * configured in `excludedCategoryCodes`. Brands with no configured exclusions get the catalogue
 * back unchanged.
 * @param {CatalogueCategory[] | null | undefined} catalogue - The catalogue returned by the `/catalogue` endpoint
 * @param {string | undefined} brandCode - The current brand code, typically `import.meta.env.VITE_BRAND_CODE`
 * @returns {CatalogueCategory[] | undefined} The catalogue with excluded categories removed, or undefined if no catalogue was provided
 */
export const filterCatalogueForBrand = (
  catalogue: CatalogueCategory[] | null | undefined,
  brandCode?: string,
): CatalogueCategory[] | undefined => {
  if (!catalogue) return undefined;

  const excluded = excludedCategoryCodes[(brandCode ?? '').trim().toUpperCase()];
  if (!excluded?.length) return catalogue;

  const excludedSet = new Set(excluded.map((code) => code.trim().toUpperCase()));

  return catalogue.filter(
    (category) => !excludedSet.has(category.categoryCode.trim().toUpperCase()),
  );
};
